var r;!function(r){r.dark="dark",r.light="light"}(r||(r={}));export{r as ThemeType};
